function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 9.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.25 12C16.25 14.6702 15.7072 17.0506 14.8647 18.7357C13.9998 20.4656 12.9436 21.25 12 21.25C11.0564 21.25 10.0002 20.4656 9.13529 18.7357C8.29276 17.0506 7.75 14.6702 7.75 12C7.75 9.32976 8.29276 6.9494 9.13529 5.26434C10.0002 3.53443 11.0564 2.75 12 2.75C12.9436 2.75 13.9998 3.53443 14.8647 5.26434C15.7072 6.9494 16.25 9.32976 16.25 12Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.83334 8.66666H21.1667",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.83334 15.3333H21.1667",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgWeb = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWeb, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Web.d4e111bd.svg";
export { ForwardRef as ReactComponent };